export class LoginCredentials {
    static jsonMap = {
        login: { key: 'login', optional: true, default: '' },
        password: { key: 'password', optional: true, default: '' }
    };

    login: string;
    password: string;
}
